
export class ApplicantSearchRequest {
  applicantRequestId: number;
  cdcNo: string;
  cocNo: string;
  nic: string;
  passportNo: string;
  userName: string;
  type: string;

}

